/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_5_TitleInputs */

const en_privacy_section_5_title = /** @type {(inputs: Privacy_Section_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Third-Party Services`)
};

const lv_privacy_section_5_title = /** @type {(inputs: Privacy_Section_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Trešo pušu pakalpojumi`)
};

/**
* | output |
* | --- |
* | "5. Third-Party Services" |
*
* @param {Privacy_Section_5_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_5_title = /** @type {((inputs?: Privacy_Section_5_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_5_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_5_title(inputs)
	return en_privacy_section_5_title(inputs)
});